import { createWidget } from '@alfa-bank/site-util-create-widget';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Aligner } from '@alfa-bank/site-aligner';

import type { IDepsDesktop, TErrorAuthorizationToEsiaDesktop } from '../model';

import { ErrorAuthorizationToEsiaDesktop as Component } from './component';

export const ErrorAuthorizationToEsiaDesktop = createWidget<
    IDepsDesktop,
    TErrorAuthorizationToEsiaDesktop
>({
    Aligner,
    Text,
})(Component);
